import { useEffect, useRef } from "react";
import styled from "styled-components";

import { Portal } from "./Map/MapPortal";
import { FieldMap$key } from "./__generated__/FieldMap.graphql";
import IconButton from "./Buttons/IconButton";
import MeasureInteraction from "./Map/MapMeasureControl";
import FieldMapContainer from "./FieldMap";

function MeasurementModal({
  field,
  enableMeasurement,
  onDismiss,
}: {
  field: FieldMap$key;
  enableMeasurement: boolean;
  onDismiss: Function;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const modalElement = ref.current;
    const preventTouch = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
    };

    // Add event listeners to prevent scrolling and propagation
    modalElement &&
      modalElement.addEventListener("touchmove", preventTouch, {
        passive: false,
      });

    return () => {
      // Clean up event listeners
      modalElement &&
        modalElement.removeEventListener("touchmove", preventTouch);
    };
  }, []);
  return (
    <Modal onClick={onDismiss} ref={ref}>
      <MapModalContainer>
        <FieldMapContainer field={field} hideMarker hideControls>
          <Portal>
            <div style={{ position: "absolute", right: 8, top: 8 }}>
              <IconButton
                icon="cross"
                size="large"
                iconColor="#000"
                backgroundColor="#FFF"
                tooltip="Sluit venster"
                onClick={() => onDismiss()}
              />
            </div>
          </Portal>
          {enableMeasurement && <MeasureInteraction />}
        </FieldMapContainer>
      </MapModalContainer>
    </Modal>
  );
}

const MapModalContainer = styled.div`
  margin-top: 5%;
  height: 80%;
  width: 90%;
`;

const Modal = styled.div<any>`
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  background: rgba(0, 0, 0, 0.5);
`;

export default MeasurementModal;
